var Vendd = (function (Vendd) {
    'use strict';

    Vendd.SalesRegistrationSystem = (function (SalesRegistrationSystem) {

        SalesRegistrationSystem.Messages = (function (Messages) {

            Messages.GetModel = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SalesRegistrationSystem.Messages.GetModel', null);
            };
            Messages.GetModel.className = 'Vendd.SalesRegistrationSystem.Messages.GetModel';

            Messages.GetModelFailed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SalesRegistrationSystem.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.SalesRegistrationSystem.Messages.GetModelFailed';

            Messages.GetModelSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SalesRegistrationSystem.Messages.GetModelSuccess', response);
            };
            Messages.GetModelSuccess.className = 'Vendd.SalesRegistrationSystem.Messages.GetModelSuccess';

            return Messages;

        })(SalesRegistrationSystem.Messages || {});

        return SalesRegistrationSystem;

    })(Vendd.SalesRegistrationSystem || {});

    return Vendd;

})(Vendd || {});